import { render } from "./NewsSearch.vue?vue&type=template&id=da680046&scoped=true"
import script from "./NewsSearch.vue?vue&type=script&lang=js"
export * from "./NewsSearch.vue?vue&type=script&lang=js"

import "./NewsSearch.vue?vue&type=style&index=0&id=da680046&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-da680046"

export default script